import React, { useEffect, useState } from 'react';
import StandardForm from './forms/StandardForm';
import LoanForm from './forms/LoanForm';
import MenteeForm from './forms/MenteeForm';
import MentorForm from './forms/MentorForm';
import TrainingForm from './forms/TrainingForm';
import CommunityForm from './forms/CommunityForm';

const CardGrid = () => {
  const [selectedForm, setSelectedForm] = useState(sessionStorage.getItem("formType") || false);

  const forms = {
    Standard: {
      component: <StandardForm />,
      image: './assets/images/standard.png',
    },
    Loan: {
      component: <LoanForm />,
      image: './assets/images/loan.png',
    },
    Mentee: {
      component: <MenteeForm />,
      image: './assets/images/mentee.png',
    },
    Mentor: {
      component: <MentorForm />,
      image: './assets/images/mentor.png',
    },
    Training: {
      component: <TrainingForm />,
      image: './assets/images/training.png',
    },
    Community: {
      component: <CommunityForm />,
      image: './assets/images/community.png',
    },
  };

  const handleClick = (name) => {
    sessionStorage.setItem("formType", name);
    setSelectedForm(name);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      const formType = sessionStorage.getItem("formType");
      if (formType !== selectedForm) {
        setSelectedForm(formType);
      }
    }, 100);

    return () => clearInterval(intervalId);
  }, [selectedForm]);

  return (
    <>
      {!selectedForm  ? (
        <div className="flex justify-center h-full overflow-auto items-center">
          <div className="grid grid-cols-2 gap-2 w-full max-w-[824px]">
            {Object.keys(forms).map((name, index) => (
              <div
                key={index}
                className="border-2 border-[#FFE6D9] hover:border-red-400 bg-[#FFE6D9] duration-500 text-center p-4 rounded-md cursor-pointer flex items-center gap-x-5 max-w-[412px] w-full"
                onClick={() => handleClick(name)}
              >
                <img src={forms[name].image} alt={`${name} Logo`} />
                <p>{name}</p>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div>
          {forms[selectedForm].component}
        </div>
      )}
    </>
  );
};

export default CardGrid;
